import Tooltip from "../../../../common/core-ui/Tooltip.tsx";

const condition =
  ":not([data-tooltip-id]):not(dialog *):not([role='dialog'] *)[data-tooltip-content]";

export default function Tooltips() {
  return <Tooltip anchorSelect={`button${condition},a${condition}`} />;
}
